import * as Sentry from '@sentry/browser';


const initSentry = () => {
  const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
  const SENTRY_RELEASE = process.env.REACT_APP_SENTRY_RELEASE;

  if (SENTRY_DSN) {
    const sentryOptions = { dsn: SENTRY_DSN };
    if (SENTRY_RELEASE) {
      sentryOptions.release = SENTRY_RELEASE;
    }

    try {
      Sentry.init(sentryOptions);
    } catch (e) {
      console.error(e);
    }
  }
};

export default initSentry;



// WEBPACK FOOTER //
// ./src/sentry.js